module.exports = __webpack_public_path__ + "static/img/product01-3.a94ba96a.png";